import { render, staticRenderFns } from "./customer-attribute.vue?vue&type=template&id=5631fa10&scoped=true&"
import script from "./customer-attribute.vue?vue&type=script&lang=js&"
export * from "./customer-attribute.vue?vue&type=script&lang=js&"
import style0 from "./customer-attribute.vue?vue&type=style&index=0&id=5631fa10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631fa10",
  null
  
)

export default component.exports